import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import queryClient from "./api/queryClient";
import { initAnalytics } from "./analytics";
import { I18nProvider } from "./i18n";
import App from "./App";
import InternalGate from './pages/InternalGate'
import ComingSoon from './pages/ComingSoon';
import ErrorBoundary from "./components/ErrorBoundary";
import { registerServiceWorker } from "./serviceWorker";

// Initialize analytics (GA4, Mixpanel, Sentry) — runs only if env vars are set
initAnalytics();

// PWA shell + offline cache. Push notifications register lazily from
// NotificationsPage when the user opts in (see src/lib/push.js).
registerServiceWorker();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <I18nProvider>
          {import.meta.env.VITE_COMING_SOON === 'true' ? <ComingSoon /> : <InternalGate><App /></InternalGate>}
        </I18nProvider>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
